import { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { CommercialMessagesContext } from '../context';
import { getEventCookieName } from '../utils';
const findActiveVoucher = (items) => {
    try {
        const currentDate = Date.now();
        return items.find(item => {
            const { startDate: start, endDate: end, voucherCode } = item;
            const startDate = Date.parse(start);
            const endDate = Date.parse(end);
            if (isNaN(startDate) || isNaN(endDate)) {
                /**
                 * Validate date format.
                 */
                return false;
            }
            const cookieName = getEventCookieName(voucherCode);
            const isEventDismissed = Cookies.get(cookieName) === 'true';
            if (startDate > currentDate || currentDate > endDate) {
                /**
                 * Validate if event is active.
                 */
                if (isEventDismissed) {
                    /**
                     * When the message was already dismissed,
                     * remove the cookie if the current date is out of the event date range.
                     */
                    Cookies.remove(cookieName);
                }
                return false;
            }
            /**
             * Validate if message was dismissed.
             */
            return !isEventDismissed;
        });
    }
    catch (e) {
        return null;
    }
};
export const useCommercialMessage = () => {
    const commercialMessageEvents = useContext(CommercialMessagesContext);
    const [event, setEvent] = useState(null);
    if (process.env.NODE_ENV !== 'production' && commercialMessageEvents === undefined) {
        throw new Error('[@pegasus/commercial-messages] `useCommercialMessage` hook needs to be used within `CommercialMessagesProvider` boundaries.');
    }
    useEffect(() => {
        const activeVoucher = findActiveVoucher(commercialMessageEvents);
        if (activeVoucher) {
            setEvent(activeVoucher);
        }
    }, [commercialMessageEvents]);
    return event;
};
//# sourceMappingURL=use-commercial-message.js.map